export default __webpack_public_path__ + "locales/sq-AL/SmartBanner.json?hash=aadb110345e428ea09a714c537ecc884";